import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=52d2d788&scoped=true&"
import script from "./AppointmentForm.vue?vue&type=script&lang=js&"
export * from "./AppointmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentForm.vue?vue&type=style&index=0&id=52d2d788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2d788",
  null
  
)

export default component.exports